import React from "react";
import {
  TableRow,
  Table,
  TableCell,
  TableHeader,
  TableHeaderColumn,
  TableBody,
} from "@backslashbuild/pp-ui";
import { useGet } from "./api";
import { utcToLocalText } from "../../utils";

const c = {
  monthNumber: 50,
  name: 90,
  calendarStartDate: 92,
  calendarEndDate: 92,
  startDate: 92,
  endDate: 92,
  dateCreated: 92,
};

const totalWidth = Object.keys(c).reduce((total, key) => (total += c[key]), 0);

function PureTable({ data, queryId }) {
  return React.useMemo(() =>
    data.value.items.map(
      (item) => (
        <TableRow key={item.id}>
          <TableCell width={c.monthNumber}>{item.monthNumber}</TableCell>
          <TableCell width={c.name}>{item.name}</TableCell>
          <TableCell width={c.calendarStartDate}>
            {utcToLocalText(item.calendarStartDate)}
          </TableCell>
          <TableCell width={c.calendarEndDate}>{utcToLocalText(item.calendarEndDate)}</TableCell>
          <TableCell width={c.startDate}>{utcToLocalText(item.startDate)}</TableCell>
          <TableCell width={c.endDate}>{utcToLocalText(item.endDate)}</TableCell>
          <TableCell width={c.dateCreated}>{utcToLocalText(item.dateCreated)}</TableCell>
        </TableRow>
      ),
      [queryId]
    )
  );
}

function TableSkeleton() {
  return (
    <TableRow>
      <TableCell width={c.name}>-</TableCell>
    </TableRow>
  );
}

function TaxMonthsTable() {
  const { data, loading, error, queryId } = useGet("tax-months");

  const isLoaded = Boolean(data?.value);

  return (
    <Table width={totalWidth} standardTable>
      <TableHeader>
        <TableHeaderColumn width={c.monthNumber}>No.</TableHeaderColumn>
        <TableHeaderColumn width={c.name}>Name</TableHeaderColumn>
        <TableHeaderColumn width={c.calendarStartDate}>Calendar Start</TableHeaderColumn>
        <TableHeaderColumn width={c.calendarEndDate}>Calendar End</TableHeaderColumn>
        <TableHeaderColumn width={c.startDate}>Start Date</TableHeaderColumn>
        <TableHeaderColumn width={c.endDate}>End Date</TableHeaderColumn>
        <TableHeaderColumn width={c.dateCreated}>Date Created</TableHeaderColumn>
      </TableHeader>
      <TableBody>
        {isLoaded ? (
          <PureTable data={data} queryId={queryId} />
        ) : data?.errors ? (
          data?.errors.map((error) => <div>{error}</div>)
        ) : (
          <TableSkeleton />
        )}
      </TableBody>
    </Table>
  );
}

export default TaxMonthsTable;
